import React, { useState } from 'react';
import './ModelDropdownMenu.css';
import { t } from './App'; // Import de la fonction de traduction

const models = [
  {
    displayName: 'Gemini 2.5 Flash',
    descriptionKey: 'modelDropdown.descriptions.gemini25Flash',
    codeName: 'gemini-2.5-flash', // same as current
    thinking: true,
  },
  {
    displayName: 'Devstral Medium',
    descriptionKey: 'modelDropdown.descriptions.devstralMedium',
    codeName: 'devstral-medium-2507',
    thinking: false,
  },
  {
    displayName: 'Codestral 2',
    descriptionKey: 'modelDropdown.descriptions.codestral2',
    codeName: 'codestral-2501',
    thinking: false,
  },
  {
    displayName: 'Magistral Medium (Experimental)',
    descriptionKey: 'modelDropdown.descriptions.magistralMedium',
    codeName: 'magistral-medium-2506',
    thinking: true,
  },
];

function ModelDropdownMenu({ selectedModel, onSelect }) {
  const [open, setOpen] = useState(false);

  const handleSelect = (model) => {
    setOpen(false);
    onSelect(model);
  };

  // Animation d'apparition du menu déroulant
  const { motion, AnimatePresence } = require('framer-motion');

  return (
    <div className="model-dropdown-menu">
      <button className="model-dropdown-toggle" onClick={() => setOpen(!open)}>
        {selectedModel ? selectedModel.displayName : t('modelDropdown.chooseModel')}
        <span className="arrow">▼</span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            className="model-dropdown-list"
            initial={{ opacity: 0, scale: 0.96, y: -8 }}
            animate={{ opacity: 1, scale: 1, y: 0, transition: { duration: 0.22, ease: 'easeOut' } }}
            exit={{ opacity: 0, scale: 0.96, y: -8, transition: { duration: 0.14, ease: 'easeIn' } }}
            style={{ borderRadius: 8, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', background: '#23242a', padding: 0, minWidth: 220, maxWidth: 320, display: 'flex', flexDirection: 'column', alignItems: 'stretch', overflow: 'hidden', transformOrigin: 'top left', position: 'absolute', zIndex: 999, border: 'none' }}
          >
            {models.map((model) => (
              <div
                key={model.codeName}
                className={`model-dropdown-item${selectedModel && selectedModel.codeName === model.codeName ? ' selected' : ''}`}
                onClick={() => handleSelect(model)}
              >
                <div className="model-name">{model.displayName}</div>
                <div className="model-desc">{t(model.descriptionKey)}</div>
                <div className="model-thinking">{t('modelDropdown.thinking')} {model.thinking ? t('modelDropdown.yes') : t('modelDropdown.no')}</div>
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default ModelDropdownMenu;
